import React, { useState, useEffect } from "react";
import { useNavigate,useParams,useLocation } from "react-router-dom";
import AthleteLayout from "../common/AthleteLayout";
import { AthleteHeader } from "../common/AthleteHeader";
import { useAthleteAuthContext } from "../login/useAthleteAuthContext";
import API_URL from "../../api/API";

export const AthleteStaticWarmupRoutinePhase = () => {
  const { athlete } = useAthleteAuthContext();

  const location = useLocation();

  // Access templates data passed via location.state
  const templates = location.state?.templates;

  const {warmup_id, template_id} = useParams();
  const navigate = useNavigate();

  const [phases, setPhases] = useState([]); // State for storing fetched phases
  const [isLoading, setIsLoading] = useState(true); // Loading state
  const [error, setError] = useState(null); // Error state
  const [selectedDate, setSelectedDate] = useState(new Date()); // State for selected date


useEffect(()=>{
  console.log("Previous State Data");
  console.log(templates);
},[templates]);

  useEffect(() => {

    const fetchPhasesData = async () => {
      try {
        const response = await fetch(API_URL.GET_STATIC_WARMUP_ROUTINE_PHASES + warmup_id, {
          method: "GET",
          headers: {
            Authorization: `Bearer ${athlete.token}`,
          },
        });

        if (!response.ok) {
          const errorData = await response.json();
          setError(errorData?.error || "Failed to fetch phases data");
          return;
        }

        const data = await response.json();
        setPhases(data); // Assuming the response has a "phases" array
      } catch (err) {
        setError(err.message); // Set error message if there is a network issue
      } finally {
        setIsLoading(false); // Set loading to false once data fetching is completed
      }
    };

    fetchPhasesData();
  }, [athlete.token, athlete.email]);

  // Function to handle date change
  const changeDate = (days) => {
    setSelectedDate((prevDate) => {
      const newDate = new Date(prevDate);
      newDate.setDate(newDate.getDate() + days);
      return newDate;
    });
  };

  // Format the date for display
  const formatDate = (date) => {
    return date.toLocaleDateString("en-US", {
      weekday: "long",
      month: "short",
      day: "numeric",
    });
  };

  const handleStaticSpeedClick = () => {
    navigate('/athlete/static-speed-workout/' + template_id + "/" + warmup_id,{ state: { templates } });
  }

  // Handle back button click and pass templates state back
  const handleBackClick = () => {
    navigate('/athlete/static-speed-workout/templates',{ state: { templates } }); // Pass templates back on go back
  };

  return (
    <AthleteLayout>
      <div className="bg-white">
        <AthleteHeader />
      </div>



      <div className="pb-3 flex flex-row justify-center items-center gap-10 bg-white">
        <ArrowL onClick={() => changeDate(-1)} />
        <p className="text-black text-xl font-normal">{formatDate(selectedDate)}</p>
        <ArrowG onClick={() => changeDate(1)} />
      </div>

      <div className="w-full max-w-2xl mx-auto h-full bg-black">
        <div className="text-white py-3 bg-black">
        
        <div className="w-full text-center relative py-4">
            <span
              className="absolute left-5 top-1/2 -translate-y-1/2 flex items-center gap-2 cursor-pointer text-white hover:text-gray-300"
              onClick={handleBackClick}
            >
              <BackArrow /> Back
            </span>
          </div>


          <div className="flex justify-between gap-[68px] mb-4 px-5">
            <button className="text-white border-b-2 border-white text-base pb-2 font-normal">
              Warmup 
            </button>
            <button onClick={() => handleStaticSpeedClick()} className="text-lightSmock text-base pb-2 font-normal">
               Workout
            </button>
          </div>

        

          {isLoading ? (
            <p className="text-white text-center">Loading phases...</p>
          ) : error ? (
            <div className="bg-red-100 text-red-500 p-3 rounded mb-4">{error}</div>
          ) : (
            <div className="space-y-[15px] overflow-hidden overflow-y-auto px-5">
              {phases &&
                phases.map((item) => (
                  <button
                    onClick={() => navigate('/athlete/static-warmup-routine/phase-exercise/' + item.phase_id + "/" + warmup_id + "/" + template_id)}
                    key={item.phase_id}
                    className="w-full p-[14px] text-white font-normal border border-white/20 bg-transparent rounded-[15px] hover:bg-white/10 transition text-start"
                  >
                    {item.title} {/* Display label here */}
                  </button>
                ))}
            </div>
          )}
        </div>
      </div>
    </AthleteLayout>
  );
};


const BackArrow = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      className="w-5 h-5"
      fill="none"
      viewBox="0 0 24 24"
      stroke="currentColor"
    >
      <path
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth={2}
        stroke="white"
        d="M15 19l-7-7 7-7"
      />
    </svg>
  );
};

const ArrowG = ({ onClick }) => {
  return (
    <svg
      onClick={onClick}
      className="hover:opacity-50 cursor-pointer"
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
    >
      <path
        d="M1 13L7 7L0.999999 1"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};

const ArrowL = ({ onClick }) => {
  return (
    <svg
      onClick={onClick}
      className="hover:opacity-50 rotate-180 cursor-pointer"
      xmlns="http://www.w3.org/2000/svg"
      width="8"
      height="14"
      viewBox="0 0 8 14"
      fill="none"
    >
      <path
        d="M1 13L7 7L0.999999 1"
        stroke="black"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
};
